export default class PurchaseConstants {
  static SCREEN_TITLE = 'Dashboard';
  static STRIPE_API_KEY = 'sk_live_kHrc4NPRaQCmDm2rFeIbPqyy';
  static CARD_NUMBER_REQUIRED = 'Card number field can\'t be blank';
  static CARD_NUMBER_SHORT_LENGTH = 'Please enter correct card number';
  static CARD_NANE_REQUIRED = 'Card name field can\'t be blank';
  static CARD_CVC_REQUIRED = 'Card cvc field can\'t be blank';
  static CARD_CVC_SHORT_LENGTH = 'Please enter correct card verification code';
  static CARD_EXPIRY_MONTH_REQUIRED = 'Card expiry month field can\'t be blank';
  static CARD_EXPIRY_YEAR_REQUIRED = 'Card expiry year field can\'t be blank';

  static TEXT_PLACEHOLDER_COLOR = 'rgb(138, 138, 138)';
  static FULL_NAME_PLACEHOLDER = 'Full Name';
  static CARD_NUMBER_PLACEHOLDER = '4242 4242 4242 4242';
  static CARD_CVC_PLACEHOLDER = '1234';
  static COUPON_CODE_PLACEHOLDER = 'ABC123';
  static PURCHASE_BUTTON_TEXT = 'Pay';

  static PAYMENT_ERROR =
    'error occured while doing payment. Please try with another card or try again later.';

  static PAYMENT_AMOUNT_DOLLARS = '199';
  static PROMO_CODE_VALIDATIONS = 'Please fill the promo code';
  static APPLY_PROMO_CODE = 'Apply Code';
  static APPLIED = 'Code Applied ';
  static DUMMY_TOKEN = 'tok_visa';
}
